import React from 'react';
import { Button, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import Header from '../../asyncIntake/Header';
import FullLayout2 from '../../asyncIntake/screens/components/FullLayout';
import { isMobile } from 'react-device-detect';
import withSession from '../../../lib/withSession';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { TextInput } from '../../../components/TextInput';
import { FormField } from '../../../components/FormField';
import RegionSelect from '../../../components/RegionSelect';
import { MaskInput } from '../../../components/async/SharedComponents';

const SuperContainer = styled(Flex)`
  width: 100vw;
  justify-content: center;
  z-index: 1;
  overflow-y: auto;
  flex: 1;
`;

const Container = styled(Flex)`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  z-index: 1;
  position: relative;
  overflow-y: none;
  margin-bottom: 36px;
  flex-direction: column;
  align-items: center;
`;

const schema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required('Required'),
  lastName: Yup.string()
    .trim()
    .required('Required'),
  street1: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.string().required('Required'),
  zip: Yup.string().required('Required'),
  phone: Yup.string().required('Required'),
});
export const ShippingAddress = withSession(({ onContinue, session }) => {
  return (
    <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
      <Header dark={false} mb={3} />
      <SuperContainer>
        <Container padding={'0 40px'}>
          <Heading textAlign={'center'} mb={3} style={{ fontSize: '26px' }}>
            Let’s confirm your mailing address for your GI Kit
          </Heading>
          <Text style={{ fontWeight: 500, fontSize: '17px', textAlign: 'center', margin: '0 20px' }} mb={3}>
            Please confirm the following information:
          </Text>

          <Formik
            isInitialValid={({ initialValues }) => schema.isValidSync(initialValues)}
            initialValues={{ firstName: session.firstName, lastName: session.lastName, ...session.address, phone: session.phone }}
            validationSchema={schema}
            onSubmit={(values) => onContinue(values)}
            render={({ isValid, errors, touched, values, handleChange, handleBlur }) => {
              let errStreet1;
              if (touched.street1 && errors.street1) {
                errStreet1 = errors.street1;
              } else if (values && values.street1 && values.street1.indexOf('@') > -1) {
                errStreet1 = 'incorrect street address';
              } else {
                errStreet1 = null;
              }
              return (
                <Form>
                  <Flex flexDirection={['column', 'column', 'row']} mt={4}>
                    <FormField width={[1, 1, 1 / 2]} mb={3} mr={[0, 0, 3]} error={touched.firstName && errors.firstName}>
                      <TextInput placeholder="First Name" type="text" name="firstName" />
                    </FormField>
                    <FormField width={[1, 1, 1 / 2]} mb={3} error={touched.lastName && errors.lastName}>
                      <TextInput placeholder="Last Name" type="text" name="lastName" />
                    </FormField>
                  </Flex>

                  <FormField mb={3} error={errStreet1}>
                    <TextInput placeholder="Address" type="text" name="street1" />
                  </FormField>

                  <FormField mb={3} error={touched.street2 && errors.street2}>
                    <TextInput placeholder="Apartment, Suite, Floor (Optional)" type="text" name="street2" />
                  </FormField>

                  <Flex mb={4} flexDirection={['column', 'column', 'row']}>
                    <FormField width={[1, 1, 1 / 3]} mb={3} mr={[0, 0, 3]} error={touched.city && errors.city}>
                      <TextInput placeholder="City" type="text" name="city" />
                    </FormField>

                    <FormField width={[1, 1, 1 / 3]} mb={3} mr={[0, 0, 3]} error={touched.state && errors.state}>
                      <RegionSelect name="state" value={values.state} />
                    </FormField>

                    <FormField width={[1, 1, 1 / 3]} mb={3} error={touched.zip && errors.zip}>
                      <TextInput placeholder="Zip" type="text" name="zip" />
                    </FormField>
                  </Flex>

                  <Text mb={1} style={{ fontSize: '12px' }}>
                    Your mobile phone number{' '}
                    <span style={{ fontSize: '10px' }}>
                      <br />
                      (In case we need to reach out regarding your kit)
                    </span>
                  </Text>
                  <FormField error={touched.phone && errors.phone}>
                    <MaskInput name="phone" placeholder="Mobile Phone Number" mask="999-999-9999" value={values.phone} onChange={handleChange} onBlur={handleBlur} id="input_phone" />
                  </FormField>

                  <Flex justifyContent="center" mt={4}>
                    <Button disabled={!isValid || !values || !values.street1 || values.street1.indexOf('@') > -1} variant="pink" width={[1, 1 / 2, 1 / 3]} type="submit">
                      Continue
                    </Button>
                  </Flex>
                </Form>
              );
            }}
          />
        </Container>
      </SuperContainer>
    </FullLayout2>
  );
});
